import Subject from "../cse4sub/Subject";
import React from 'react'

export default function Egd() {
  return (
    <div>
       <Subject title="Engineering Graphics & Design(ASH106)" sub="E. Graphics & Design" syllabus="#"
    book1=") Bhatt N.D., Panchal V.M. & Ingle P.R., (2014), Engineering Drawing, Charotar Publishing House" 
    book2=" "
    book1Link="https://soaneemrana.com/onewebmedia/ENGINEERING%20DRAWING%20BY%20N.D%20BHATT.pdf"
     book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}